export default __webpack_public_path__ + "static/Entenda0113-df01a2ff01d54975d9a3e03459c62c00.jpg";